import React from 'react';
import { Badge, BadgeType } from '../../../../../../components/badge/badge';
import Section from './section';
import { humanizeValue } from '../../profile-explanation-utils';

interface IFeatureDetailsSectionProps {
    featureDetails: {
        feature_id?: number;
        feature_name?: string | null;
        is_enabled?: boolean;
        default_value?: unknown;
        description?: string;
    };
}

const FeatureDetailsSection: React.FC<IFeatureDetailsSectionProps> = ({ featureDetails }) => {
    return (
        <Section title="Feature details">
            <div className="profile-explanation-feature">
                <div className="profile-explanation-feature-row">
                    <span className="profile-explanation-label">Feature</span>
                    <span>
                        {featureDetails.feature_name != null
                            ? `${featureDetails.feature_name} (ID: ${featureDetails.feature_id})`
                            : `ID: ${featureDetails.feature_id}`}
                    </span>
                </div>
                <div className="profile-explanation-feature-row">
                    <span className="profile-explanation-label">Enabled</span>
                    <Badge 
                        type={featureDetails.is_enabled ? BadgeType.SUCCESS : BadgeType.WARNING} 
                        text={humanizeValue(featureDetails.is_enabled)}
                    />
                </div>
                {featureDetails.description && (
                    <p className="profile-explanation-description">{featureDetails.description}</p>
                )}
            </div>
        </Section>
    );
};

export default FeatureDetailsSection;
